import { lowerCase } from 'lodash-es';

import type { BoxWithLabel, FrameData } from '@/type';

const convertBoxWithLabel = (v: UnwrapArray<FrameData['workData']>) =>
  ({
    ...v,
    label: lowerCase(v.label),
  }) as BoxWithLabel;

export default convertBoxWithLabel;
